import React from 'react'
import './carousel.css'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

let InternaImg = require('../../src/assets/img/politica-interna.png')
let ExternaImg = require('../../src/assets/img/politica-externa.png')
let CulturaImg = require('../../src/assets/img/cultura.png')
let SociedadImg = require('../../src/assets/img/sociedad.png')
let EconomiaImg = require('../../src/assets/img/economia.png')

const SucesosSubSections = (props) => {
  let { info } = props;
  let iconTitle = (info.type === 'interna') ? InternaImg :
    (info.type === 'externa') ? ExternaImg :
      (info.type === 'cultura') ? CulturaImg :
        (info.type === 'sociedad') ? SociedadImg : EconomiaImg;

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ display: 'flex' }}>
        <img src={iconTitle} style={{ paddingRight: 5, height: '1.75rem', marginTop: '0.3rem', marginBottom: 0}} alt=""/>
        <Typography variant="caption" style={{ color: '#408ed6', fontSize: '1rem', margin: '0.5rem 0.2rem 0.2rem 0' }}
                    color='caption'>
          {info.title}
        </Typography>
      </div>
      <div className='subSectionSucesos' style={{ marginTop: 10 }}
           dangerouslySetInnerHTML={{ __html: info.data }}/>
      <Divider style={{ backgroundColor: '#9E9E9E', opacity: '0.8', margin: 20 }}/>
    </div>
  )
}

export default SucesosSubSections


// WEBPACK FOOTER //
// ./src/components/sucesosSubSections.js